module.exports = __webpack_public_path__ + "fo.375ebd5e6d867a183253.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/fo.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/fo.svg
// module chunks = styles